import React, { useEffect, useState } from "react";
import { Form, message, Row, Col } from "antd";
import { SaveButton, CancelButton, ModalComponent, trans, InputTime, InputDate, InputTextArea, SelectResourceList } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { createDataReq, getRosterReq } from "../requests";
import { Commons, Const } from "../../../constants";
import RoasterView from "@mods/common/RoasterView";
import { convertTimeTotz } from '@comps/commonFunctions';
import { makeFieldLabel } from "@utils/fieldTooltips";
import { travelTooltips } from "../../../common/travelTooltips";


const langKey = Const["companyOfficialDuty"].lngKey


const fieldLabel = makeFieldLabel(travelTooltips.officialDuty, { namespace: "officialDuty", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createOfficialDutiesRequest";
const CreateCompanyOfficalDutyReq = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [roasterView, setRoasterView] = useState(null)
  const [shifts, setShifts] = useState({})
  const [selectedEmploymentId, setEmploymentId] = useState(null);
  const [form] = Form.useForm()
  useEffect(() => {

    // eslint-disable-next-line
  }, []);

  const onChangeEmployment = (id) => {
    setEmploymentId(id);
  }
  const getRoster = (date) => {
    if (date) {
      const payload = { official_duty: { employment_id: props.module !== "myOfficialDuty" ? selectedEmploymentId : props.authUser.employment_id, date: date.format('YYYY-MM-DD') } }
      makeRequest(setLoader, getRosterReq, payload, onGetRosterSuccess, onGetRosterSuccess);
    }
  }

  const onGetRosterSuccess = (response, data) => {
    if (data.shifts) {
      setRoasterView(<RoasterView record={ data } />)
      setShifts(data.shifts[convertTimeTotz(data.from_date).format('YYYYMMDD') + '-' + data.employments[0].id][0]);
      let start_time = data.shifts[convertTimeTotz(data.from_date).format('YYYYMMDD') + '-' + data.employments[0].id][0]['start']
      let end_time = data.shifts[convertTimeTotz(data.from_date).format('YYYYMMDD') + '-' + data.employments[0].id][0]['end']

      form.setFieldsValue({
        start_time: convertTimeTotz(start_time),
        end_time: convertTimeTotz(end_time),
      })
    }
  }

  const onSubmit = (data) => {
    const payload = { official_duty: { shift: shifts, employment_id: shifts.employment_id, date: data.date.format('YYYY-MM-DD'), start_time: data.start_time.second(0), end_time: data.end_time.second(0), reason: data.reason, employee_shift_id: shifts.id }, filters: props.filters };
    setSaveLoader(true)
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);

  }

  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Saved successfully");
    props.onCompleted(data.official_duties.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];
  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------
  return (
    <ModalComponent top={ 20 } width={ 680 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit }>
        <Row gutter={ 30 }>
          {
            props.module !== "myOfficialDuty" ?
              <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                <Form.Item name="employment_id" rules={ rules.employment_id } label={ fieldLabel("employment_id", trans(`${langKey}.employment_id`)) }
                  className="da-mb-16"
                  { ...getErrorProps(errors['name']) } size="small"
                >
                  <SelectResourceList type='employment'
                    onChange={ (id) => onChangeEmployment(id) }
                  />
                </Form.Item>
              </Col>
              : ''
          }


          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="date" rules={ rules.date } label={ fieldLabel("date", trans(`${langKey}.date`)) }
              className="da-mb-16"
              { ...getErrorProps(errors['date']) } size="small"
            >
              <InputDate onChange={ (e) => getRoster(e) } />
            </Form.Item>
          </Col>
        </Row>
        { roasterView }
        <Row gutter={ 30 }>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="start_time" rules={ rules.start_time } label={ fieldLabel("start_time", trans(`${langKey}.start_time`)) }
              className="da-mb-16"
              { ...getErrorProps(errors['start_time']) } size="small"
            >
              <InputTime placeholder={ trans(`${langKey}.start_time`) } />
            </Form.Item>
          </Col>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="end_time" rules={ rules.end_time } label={ fieldLabel("end_time", trans(`${langKey}.end_time`)) }
              className="da-mb-16"
              { ...getErrorProps(errors['end_time']) } size="small"
            >
              <InputTime placeholder={ trans(`${langKey}.end_time`) } />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="reason" rules={ rules.reason } label={ fieldLabel("reason", trans(`${langKey}.reason`)) }
              className="da-mb-16"
              { ...getErrorProps(errors['reason']) } size="small"
            >
              <InputTextArea placeholder={ trans(`${langKey}.reason`) } />
            </Form.Item>
          </Col>
        </Row>

      </Form>
    </ModalComponent>
  )
}

export default CreateCompanyOfficalDutyReq

const rules = {
  date: [
    { required: true, message: trans(`${langKey}.date.req`) },
  ],
  start_time: [
    { required: true, message: trans(`${langKey}.start_time.req`) },
  ],
  end_time: [
    { required: true, message: trans(`${langKey}.end_time.req`) },
  ],
  reason: [
    { required: true, message: trans(`${langKey}.reason.req`) },
  ],
  employment_id: [
    { required: true, message: trans(`${langKey}.employment_id.req`) },
  ],
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}